export const ROUTES = {
  root: "/",
  caterers: "/caterers",
  checkout: "/revieworder",
  orders: "/orders",
  confirmedOrder: "/orderconfirmed",
  login: "/login",
  admin: "/admin",
};
